import { CardAttributeDtoToEntity } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/services/mappers/CardAttributeDtoToEntity";
import type { CardAttributeDto } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/types/CardAttributeDto";
import type { CardAttributeEntity } from "src/app/features/CardImplementation/subFeatures/CardDefinition/subFeatures/CardAttribute/types/CardAttributeEntity";
import type { ResourcePageDto } from "../../../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const CardAttributeTableDtoMapper = (
    input: Readonly<ResourcePageDto<CardAttributeDto>>,
): ResourcePageEntity<CardAttributeEntity> => {
    return {
        list: input.list ? input.list.map(CardAttributeDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
